import { useState, useEffect } from "react";
import {
  CheckCircle,
  Loader,
  AlertTriangle,
  ClipboardList,
  User,
} from "lucide-react";

const Boxcard = () => {
  const [totalSchools, setTotalSchools] = useState(0);
  const [pendingSchools, setPendingSchools] = useState(0);
  const [totalForms, setTotalForms] = useState(0);
  const [activeSubs, setActiveSubs] = useState(0);
  const [expiredSubs, setExpiredSubs] = useState(0);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await fetch(
        "https://support.ace-school-backend.serverscripts.in/api/v1/admin/dashboard",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch dashboard");

      const result = await response.json();
      const data = result.data;
      console.log(data);
      setTotalSchools(data.total_schools);
      setPendingSchools(data.pending_schools);
      setTotalForms(data.total_forms);
      setActiveSubs(data.active_subscriptions);
      setExpiredSubs(data.expired_subscriptions);
    } catch (err) {
      console.error("Error fetching dashboard:", err);
    }
  };

  return (
    <div className="Dashboard-1">
      <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
  <li className="dashboard-card">
    <User className="icon text-gray-700" />
    <h3>Total Schools</h3>
    <p>{totalSchools}</p>
  </li>

  <li className="dashboard-card">
    <AlertTriangle className="icon text-yellow-600" />
    <h3>Pending Schools</h3>
    <p>{pendingSchools}</p>
  </li>

  <li className="dashboard-card">
    <ClipboardList className="icon text-purple-600" />
    <h3>Total Forms</h3>
    <p>{totalForms}</p>
  </li>

  <li className="dashboard-card">
    <Loader className="icon text-blue-600" />
    <h3>Active Subscriptions</h3>
    <p>{activeSubs}</p>
  </li>

  <li className="dashboard-card">
    <CheckCircle className="icon text-green-600" />
    <h3>Expired Subscriptions</h3>
    <p>{expiredSubs}</p>
  </li>
</ul>
    </div>
  );
};

export default Boxcard;